import {
    apiRequest,
    pemutihanAbsenDetail
} from "../../../../../services/adapters/kepegawaian/pemutihanAbsenService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pemutihanAbsenDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository